<script lang="ts">
import { defineComponent, ref } from "vue";
import { inputChangeHandler } from "@/businesslogic/utils/events";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "TarifoptionenSelect",
  methods: { inputChangeHandler },
  props: {
    typ: String,
    produktlinien: Array,
    selectName: String,
    selectOptionen: Array,
    modelValue: [Number, String],
  },
  setup(props) {
    const piniaStore = useFormStore();
    const name = ref(props.selectName);
    const selectOptions = ref(props.selectOptionen);

    const getCssForCol = (produktlinie: string) => {
      if (props.produktlinien?.length === 2) {
        return "add-on__option twoCols " + (istGewaehlteProduktLinie(produktlinie) ? "active" : "");
      }
      return "add-on__option " + (istGewaehlteProduktLinie(produktlinie) ? "active" : "");
    };

    const istGewaehlteProduktLinie = (produktLinie: string) => {
      return piniaStore.state.tarifinformationen.produktLinie === produktLinie;
    };

    const decorateSummeFuerAnzeige = (value: number | string) => {
      let valueToDecorate: number = typeof value === "number" ? value : parseInt(value);

      switch (props.typ) {
        case "deckungssumme-hg": {
          if (valueToDecorate == 500) {
            valueToDecorate = 250;
          }
          return valueToDecorate / 10 + " Mio. €";
        }
        case "deckungssumme": {
          return valueToDecorate / 10 + " Mio. €";
        }
        case "selbstbeteiligung": {
          return valueToDecorate == 0 ? "Keine" : valueToDecorate + " €";
        }
        case "anzahlvorschaeden": {
          if (valueToDecorate == -1) {
            return "Bitte wählen";
          } else if (valueToDecorate == 5) {
            return "5 und mehr";
          }
          return valueToDecorate;
        }
        case "schadenfreiheitsrabatt": {
          return valueToDecorate == 1 ? "Ja" : "Nein";
        }
        default:
          return "";
      }
    };

    const pruefeVorbelegung = (option: { value: number; label: string }) => {
      if (
        props.typ == "schadenfreiheitsrabatt" &&
        piniaStore.state.tarifinformationen.sfrAusVorbelegung != "" &&
        option.value == 1
      ) {
        return option.label + " (" + piniaStore.state.tarifinformationen.sfrAusVorbelegung + ")";
      }
      return option.label;
    };

    const sollOptionDeaktiviertWerden = (value: number) => {
      return (
        piniaStore.state.verkaufsprodukt === "HG" &&
        piniaStore.state.tarifinformationen.produktLinie === "002" &&
        value === 500
      );
    };

    return {
      props,
      name,
      selectOptions,
      getCssForCol,
      istGewaehlteProduktLinie,
      decorateSummeFuerAnzeige,
      sollOptionDeaktiviertWerden,
      pruefeVorbelegung,
    };
  },
});
</script>

<template>
  <div
    class="o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200"
  >
    <div class="tarif-options-module tarif-options-module--add-on">
      <div class="o-grid o-grid--no-y-gutter add-on">
        <div v-for="produktLinie in props.produktlinien" :key="produktLinie" :class="getCssForCol(produktLinie)">
          <div v-if="istGewaehlteProduktLinie(produktLinie)" class="c-form-control">
            <select
              :name="name"
              :value="modelValue"
              @input="$emit('update:modelValue', inputChangeHandler($event))"
              class="chooseOptionsSelect c-form-control-select u-text-align-center u-mar-0"
              :data-cy="name"
              :aria-label="name"
            >
              <option
                v-for="(option, index) in selectOptions"
                :key="index"
                :value="option.value"
                :disabled="sollOptionDeaktiviertWerden(option.value)"
              >
                {{ pruefeVorbelegung(option) }}
              </option>
            </select>
          </div>
          <div v-else class="u-text-align-center">
            {{ decorateSummeFuerAnzeige(modelValue) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
